// extracted by mini-css-extract-plugin
module.exports = {"grid":"GridAdapter_grid__2U8wL"};